import type { Arrow } from './types';
import type { RenderLayout } from './renderer';
import { gridToScreen } from './renderer';

function distToSegment(
  px: number, py: number,
  ax: number, ay: number,
  bx: number, by: number
): number {
  const dx = bx - ax;
  const dy = by - ay;
  const lenSq = dx * dx + dy * dy;
  if (lenSq === 0) return Math.hypot(px - ax, py - ay);
  const t = Math.max(0, Math.min(1, ((px - ax) * dx + (py - ay) * dy) / lenSq));
  return Math.hypot(px - (ax + t * dx), py - (ay + t * dy));
}

export function pickArrow(
  screenX: number,
  screenY: number,
  arrows: Arrow[],
  layout: RenderLayout,
  threshold: number
): Arrow | null {
  let best: Arrow | null = null;
  let bestDist = Infinity;

  for (const arrow of arrows) {
    for (let i = 0; i < arrow.points.length - 1; i++) {
      const a = gridToScreen(arrow.points[i].col, arrow.points[i].row, layout);
      const b = gridToScreen(arrow.points[i + 1].col, arrow.points[i + 1].row, layout);
      const d = distToSegment(screenX, screenY, a.x, a.y, b.x, b.y);
      if (d < bestDist) {
        bestDist = d;
        best = arrow;
      }
    }
  }

  return bestDist <= threshold ? best : null;
}
